import { inject, InjectionToken } from '@angular/core';

export interface SourcePreviewConfiguration {
	canNavigateToNode: boolean;
	modalFullscreen: boolean;
	downloadLogic?: (fileUrl: string, name?: string) => Promise<void>;
}

export const DEFAULT_SOURCE_PREVIEW_CONFIGURATION: SourcePreviewConfiguration = {
	canNavigateToNode: true,
	modalFullscreen: false,
};

export const SOURCE_PREVIEW_CONFIGURATION = new InjectionToken<Partial<SourcePreviewConfiguration>>(
	'SOURCE_PREVIEW_CONFIGURATION',
	{
		factory: () => ({}),
	}
);

export function injectConfiguration(): SourcePreviewConfiguration {
	const givenConfiguration = inject(SOURCE_PREVIEW_CONFIGURATION);
	return { ...DEFAULT_SOURCE_PREVIEW_CONFIGURATION, ...givenConfiguration };
}

export function provideSourcePreviewConfiguration(
	configuration: Partial<SourcePreviewConfiguration>
) {
	return {
		provide: SOURCE_PREVIEW_CONFIGURATION,
		useValue: {
			...DEFAULT_SOURCE_PREVIEW_CONFIGURATION,
			...configuration,
		},
	};
}

export function provideSourcePreviewConfigurationFactory(
	configurationFactory: () => Partial<SourcePreviewConfiguration>
) {
	return {
		provide: SOURCE_PREVIEW_CONFIGURATION,
		useFactory: () => {
			return {
				...DEFAULT_SOURCE_PREVIEW_CONFIGURATION,
				...configurationFactory(),
			};
		},
	};
}
